import React from 'react';

import { Locales } from 'src/lib/constants';
import { ResourcesSearchTemplate } from 'src/templates';
import { getResourcesSearchStaticProps } from 'src/lib/resources-page-data';

const TopicPage = (props) => {
  return <ResourcesSearchTemplate {...props} locale={Locales.EN_US} />;
};

export async function getStaticProps({ preview }) {
  return getResourcesSearchStaticProps({
    locale: Locales.EN_US,
    preview,
  });
}

export default TopicPage;
